/* eslint no-param-reassign: ["error", { "props": false }] */
import Vue from 'vue';
import Vuex from 'vuex';

import auth from './modules/auth';
import tasks from './modules/tasks';
import projects from './modules/projects';
import skills from './modules/skills';
import taskCompletion from './modules/task_completion';
import organizer from './modules/organizer';
import users from './modules/users';
import gallery from './modules/gallery';
import messages from './modules/messages';
import shared from './modules/shared';
import completionQuestions from './modules/completion_questions';
import browseTasks from './modules/browse_tasks';

Vue.use(Vuex);


const store = new Vuex.Store({
  modules: {
    auth,
    tasks,
    projects,
    shared,
    skills,
    taskCompletion,
    organizer,
    users,
    gallery,
    messages,
    completionQuestions,
    browseTasks,
  },
});

export default store;



// WEBPACK FOOTER //
// ./src/store/index.js